export interface IdentityHandle {
  readonly _brand: 'IdentityHandle';
  readonly identityExport: Uint8Array;
}

export interface IdentityManager {
  generateIdentity(): Promise<IdentityHandle>;
  wrapIdentity(seed: Uint8Array): Promise<void>;
  unwrapIdentity(): Promise<Uint8Array | null>;
  forgetIdentity(): Promise<void>;
}

export class IdentityCorruptionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'IdentityCorruptionError';
  }
}

// IdentityKeyUnavailableError — the wrapped identity ciphertext exists but the
// key needed to decrypt it is missing/unreadable right now (e.g. the browser
// evicted only the wrap-key IndexedDB record under storage pressure / ITP, or
// the keystore is momentarily locked). This is a TRANSIENT, RECOVERABLE
// condition — NOT genuine corruption — so callers must PRESERVE credentials and
// retry, never wipe the refresh token or regenerate identity. It is deliberately
// distinct from IdentityCorruptionError (key present, decrypt still fails →
// genuine tamper/corruption) so the bootstrap can treat the two differently.
export class IdentityKeyUnavailableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'IdentityKeyUnavailableError';
  }
}
